<div class="mx-auto p-6 bg-white">
  <!-- ⚠️ BANNER DE DEPRECACIÓN -->
  <div class="mb-6 bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-lg">
    <div class="flex items-start gap-3">
      <div class="flex-shrink-0">
        <svg class="h-6 w-6 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>
      <div class="flex-1">
        <h3 class="text-sm font-bold text-amber-800">⚠️ Vista Deprecada</h3>
        <p class="mt-1 text-sm text-amber-700">
          Esta vista está siendo reemplazada por una versión mejorada. Por favor, utiliza la nueva versión para una
          mejor experiencia.
        </p>
        <div class="mt-3">
          <a *ngIf="enrollment" [routerLink]="['/dashboard/enrollments/view-v2/', enrollment.id]"
            class="inline-flex items-center gap-2 px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white text-sm font-medium rounded-lg transition-colors shadow-sm">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
            Ir a la Nueva Vista
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- 🆕 Encabezado con estado de inscripción -->
  <div class="flex flex-wrap items-center justify-between gap-4 mb-6">
    <div class="flex items-center gap-4">
      <h1 class="text-3xl font-bold">Detalle de Inscripción</h1>
      <span *ngIf="enrollment" class="px-3 py-1.5 text-sm font-bold rounded-full"
        [ngClass]="getEnrollmentStatusClass(enrollment.status)">
        {{ getEnrollmentStatusLabel(enrollment.status) }}
      </span>
    </div>
    <div class="text-sm text-gray-500" *ngIf="enrollment">
      ID: <span class="font-medium text-gray-700">#{{ enrollment.id }}</span>
    </div>
  </div>

  <!-- 🆕 Historial de Movimientos de Cartera (Timeline) -->
  <div *ngIf="hasMovementHistory()" class="mb-6">
    <div class="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 rounded-xl border border-blue-200">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-lg font-bold text-blue-800 flex items-center gap-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Historial de Movimientos de Cartera
        </h3>
        <span class="px-2 py-1 text-xs font-medium bg-blue-200 text-blue-800 rounded-full">
          {{ movementHistory.length }} movimiento(s)
        </span>
      </div>

      <!-- Timeline de movimientos -->
      <div class="relative">
        <!-- Línea vertical del timeline -->
        <div class="absolute left-4 top-0 bottom-0 w-0.5 bg-gray-300"></div>

        <!-- Eventos del timeline -->
        <div class="space-y-4">
          <div *ngFor="let movement of movementHistory; let i = index; let last = last" class="relative pl-10">
            <!-- Punto del timeline -->
            <div
              class="absolute left-2 w-5 h-5 rounded-full border-2 border-white shadow-md flex items-center justify-center"
              [ngClass]="getTimelineDotClass(movement.movementType)">
              <span class="text-white text-xs">{{ i + 1 }}</span>
            </div>

            <!-- Contenido del evento -->
            <div class="p-4 rounded-lg border-l-4 shadow-sm" [ngClass]="getMovementClass(movement.movementType)">
              <div class="flex flex-wrap items-start justify-between gap-2">
                <div class="flex-1">
                  <div class="flex items-center gap-2 mb-1">
                    <span class="text-lg">{{ getMovementIcon(movement.movementType) }}</span>
                    <span class="font-bold">{{ movement.movementTypeDescription }}</span>
                    <span *ngIf="movement.isReverted"
                      class="px-2 py-0.5 text-xs bg-gray-200 text-gray-700 rounded-full">
                      Revertido
                    </span>
                  </div>
                  <p class="text-sm opacity-80">
                    {{ movement.movementDate | date:'medium' }}
                  </p>
                </div>
                <div class="text-right">
                  <p class="text-xs opacity-70">Monto afectado</p>
                  <p class="font-bold">{{ movement.totalAffectedAmount | currency }}</p>
                  <p class="text-xs opacity-70">{{ movement.affectedInstallmentsCount }} cuota(s)</p>
                </div>
              </div>

              <!-- Razón del movimiento -->
              <div *ngIf="movement.reason" class="mt-3 p-2 bg-white/50 rounded">
                <p class="text-xs font-medium opacity-70">📝 Razón:</p>
                <p class="text-sm">{{ movement.reason }}</p>
              </div>

              <!-- Notas adicionales -->
              <div *ngIf="movement.notes" class="mt-2 p-2 bg-white/50 rounded">
                <p class="text-xs font-medium opacity-70">📋 Notas:</p>
                <p class="text-sm">{{ movement.notes }}</p>
              </div>

              <!-- Información de proyecto destino (si aplica) -->
              <div *ngIf="movement.targetProjectName" class="mt-2 flex items-center gap-2 text-sm">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
                <span class="opacity-70">Migrado a:</span>
                <span class="font-medium">{{ movement.targetProjectName }}</span>
              </div>

              <!-- Usuario que realizó el movimiento -->
              <div class="mt-2 flex items-center gap-2 text-xs opacity-60">
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <span>Realizado por: {{ movement.performedBy }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Banner de Estado Actual (solo si está retirada o aplazada Y no tiene historial visible) -->
  <div *ngIf="isEnrollmentWithdrawnOrDeferred() && !hasMovementHistory()" class="mb-6 p-4 rounded-xl border-l-4"
    [ngClass]="{
           'bg-red-50 border-red-500': enrollment.status === 2 || enrollment.status === 'Withdrawn',
           'bg-orange-50 border-orange-500': enrollment.status === 3 || enrollment.status === 'Deferred'
         }">
    <div class="flex items-start gap-4">
      <div class="flex-shrink-0">
        <svg *ngIf="enrollment.status === 2 || enrollment.status === 'Withdrawn'" class="w-8 h-8 text-red-500"
          fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <svg *ngIf="enrollment.status === 3 || enrollment.status === 'Deferred'" class="w-8 h-8 text-orange-500"
          fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <div class="flex-1">
        <h3 class="text-lg font-bold" [ngClass]="{
                'text-red-800': enrollment.status === 2 || enrollment.status === 'Withdrawn',
                'text-orange-800': enrollment.status === 3 || enrollment.status === 'Deferred'
              }">
          Inscripción {{ getEnrollmentStatusLabel(enrollment.status) }}
        </h3>
        <p class="text-sm mt-1" [ngClass]="{
               'text-red-700': enrollment.status === 2 || enrollment.status === 'Withdrawn',
               'text-orange-700': enrollment.status === 3 || enrollment.status === 'Deferred'
             }">
          Esta inscripción tiene cartera castigada y no genera cobros activos.
        </p>
        <div *ngIf="enrollment.withdrawalReason" class="mt-3 p-3 rounded-lg" [ngClass]="{
                 'bg-red-100': enrollment.status === 2 || enrollment.status === 'Withdrawn',
                 'bg-orange-100': enrollment.status === 3 || enrollment.status === 'Deferred'
               }">
          <p class="text-xs font-medium mb-1" [ngClass]="{
                 'text-red-600': enrollment.status === 2 || enrollment.status === 'Withdrawn',
                 'text-orange-600': enrollment.status === 3 || enrollment.status === 'Deferred'
               }">📝 Razón / Observaciones:</p>
          <p class="text-sm" [ngClass]="{
                 'text-red-900': enrollment.status === 2 || enrollment.status === 'Withdrawn',
                 'text-orange-900': enrollment.status === 3 || enrollment.status === 'Deferred'
               }">{{ enrollment.withdrawalReason }}</p>
        </div>
      </div>
      <div class="flex-shrink-0">
        <span class="px-3 py-1 text-sm font-bold rounded-full" [ngClass]="getEnrollmentStatusClass(enrollment.status)">
          {{ getEnrollmentStatusLabel(enrollment.status) }}
        </span>
      </div>
    </div>
  </div>

  <!-- Información del Proyecto -->
  <section class="pt-10 mt-10 border-t border-gray-200">
    <!-- Header -->
    <div class="flex items-center justify-between mb-6">
      <h2 class="text-2xl font-semibold text-gray-800">Proyecto</h2>

      <a [routerLink]="['/projects/view-project', enrollment.project.id]" target="_blank" rel="noopener noreferrer"
        class="inline-flex items-center gap-2 text-sm bg-white text-blue-600 border border-blue-100 px-3 py-1.5 rounded-md shadow-sm hover:bg-blue-50 transition">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
        </svg>
        Ver proyecto completo
      </a>
    </div>

    <!-- Info Cards -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <!-- Card izquierda -->
      <div class="bg-gray-50 p-5 rounded-lg shadow-sm border border-gray-200">
        <p class="text-lg font-semibold text-gray-800 mb-2">
          {{ enrollment.project.name }}
        </p>
        <ul class="text-gray-700 text-sm space-y-1">
          <li><strong>ID del Proyecto:</strong> {{ enrollment.project.projectId }}</li>
          <li><strong>Descripción:</strong> {{ enrollment.project.description }}</li>
        </ul>
      </div>

      <!-- Card derecha -->
      <div class="bg-gray-50 p-5 rounded-lg shadow-sm border border-gray-200">
        <p class="text-lg font-semibold text-gray-800 mb-2">Detalles del Proyecto</p>
        <ul class="text-gray-700 text-sm space-y-1">
          <li><strong>Período:</strong> {{ enrollment.project.period }}</li>
          <li><strong>Estado:</strong> {{ enrollment.project.status }}</li>
          <li><strong>Duración:</strong> {{ enrollment.project.duration }} semanas</li>
        </ul>
      </div>
    </div>
  </section>

  <!-- Detalles Financieros -->
  <section class="pt-10 mt-10 border-t border-gray-200">
    <h2 class="text-2xl font-semibold mb-6 text-gray-800">Detalles Financieros</h2>

    <!-- Bloque 1: Inscripción y Descuento -->
    <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
      <!-- Valor Proyectado -->
      <div class="bg-white border border-gray-200 rounded-xl p-5 shadow-sm">
        <p class="text-sm text-gray-500 mb-1 flex items-center gap-2">
          <svg class="w-4 h-4 text-green-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 8c-1.657 0-3 1.343-3 3h3v3c1.657 0 3-1.343 3-3s-1.343-3-3-3z" />
          </svg>
          Valor Matrícula Proyectado
        </p>
        <p class="text-xl font-bold text-green-600">
          {{ getProjectInscriptionAmount() }}
        </p>
      </div>

      <!-- Valor Ejecutado -->
      <div class="bg-white border border-gray-200 rounded-xl p-5 shadow-sm">
        <p class="text-sm text-gray-500 mb-1 flex items-center gap-2">
          <svg class="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 8v4l3 3m6-7v13a2 2 0 01-2 2H6a2 2 0 01-2-2V7a2 2 0 012-2h7l5 5z" />
          </svg>
          Valor Matrícula Ejecutado
        </p>
        <p class="text-xl font-bold text-blue-600">
          {{ formatCurrencyValue(enrollment.totalAmount, enrollment?.currencySymbol, enrollment?.currencyCode) }}
        </p>
      </div>

      <!-- % Descuento -->
      <div class="bg-white border border-gray-200 rounded-xl p-5 shadow-sm">
        <p class="text-sm text-gray-500 mb-1 flex items-center gap-2">
          <svg class="w-4 h-4 text-purple-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 19V6h13M9 6L3 12l6 6" />
          </svg>
          Porcentaje de Descuento
        </p>
        <p class="text-xl font-bold text-purple-600">{{ enrollment.discount | number:'1.0-2' }}%</p>
      </div>

      <!-- Valor Descuento -->
      <div class="bg-white border border-gray-200 rounded-xl p-5 shadow-sm">
        <p class="text-sm text-gray-500 mb-1 flex items-center gap-2">
          <svg class="w-4 h-4 text-red-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Descuento Aplicado
        </p>
        <p class="text-xl font-bold text-red-600">-{{ formatCurrencyValue(enrollment.discountAmount,
          enrollment?.currencySymbol, enrollment?.currencyCode) }}</p>
      </div>
    </div>
  </section>


  <!-- Información del Estudiante -->
  <section class="pt-10 mt-10 border-t border-gray-200">
    <!-- Header -->
    <div class="flex items-center justify-between mb-6">
      <h2 class="text-2xl font-semibold text-gray-800 flex items-center gap-2">
        Estudiante
      </h2>

      <a [routerLink]="['/dashboard/participants/profile-participant', enrollment.participant.id]" target="_blank"
        class="inline-flex items-center gap-2 text-sm bg-white text-blue-600 border border-blue-100 px-3 py-1.5 rounded-md shadow-sm hover:bg-blue-50 transition">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
        </svg>
        Ver perfil completo
      </a>
    </div>

    <!-- Información en Cards -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <!-- Card izquierda -->
      <div class="bg-gray-50 p-5 rounded-lg shadow-sm border border-gray-200">
        <p class="text-lg font-semibold text-gray-800 mb-2">
          {{ enrollment.participant.firstName }} {{ enrollment.participant.lastName }}
        </p>
        <ul class="text-gray-700 text-sm space-y-1">
          <li><strong>Documento:</strong> {{ enrollment.participant.typeDocument }} {{ enrollment.participant.documentId
            }}</li>
          <li><strong>Correo:</strong> {{ enrollment.participant.email }}</li>
          <li><strong>Celular:</strong> {{ enrollment.participant.cellPhone }}</li>
        </ul>
      </div>

      <!-- Card derecha -->
      <div class="bg-gray-50 p-5 rounded-lg shadow-sm border border-gray-200">
        <p class="text-lg font-semibold text-gray-800 mb-2">Información adicional</p>
        <ul class="text-gray-700 text-sm space-y-1">
          <li><strong>Dirección:</strong> {{ enrollment.participant.addressLine1 }}, {{ enrollment.participant.city }},
            {{ enrollment.participant.country }}</li>
          <li><strong>Edad:</strong> {{ enrollment.participant.age }} años</li>
          <li><strong>Profesión:</strong> {{ enrollment.participant.profession }}</li>
          <li><strong>Empresa:</strong> {{ enrollment.participant.company?.name || 'N/A' }}</li>
        </ul>
      </div>
    </div>
  </section>


  <!-- Plan de Pagos - Versión Mejorada -->
  <section class="pt-8 mt-8 border-t border-gray-200">
    <!-- Encabezado con resumen visual -->
    <div class="mb-6">
      <div class="flex flex-wrap items-center justify-between gap-4 mb-6">
        <div>
          <h2 class="text-2xl font-semibold text-gray-800">Plan de Pagos</h2>
          <p class="text-sm text-gray-500 mt-1">
            {{ enrollment.paymentPlans.length }} cuotas programadas •
            <span class="text-green-600">{{ getCompletedPayments() }} pagadas</span> •
            <span class="text-orange-500">{{ getPendingPayments() }} pendientes</span>
          </p>
        </div>

        <div class="flex gap-3">
          <a [routerLink]="['/dashboard/enrollments/view/', enrollment.id, 'edit-payment-plans']" target="_blank"
            class="inline-flex items-center gap-2  text-blue-600 border border-blue-100 px-3 py-1.5 rounded hover:bg-blue-50 hover:text-blue-800 transition">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
            </svg>
            Editar plan de pagos
          </a>
          <button (click)="togglePunishMode()"
            class="inline-flex items-center gap-2 border border-red-200 text-red-700 px-3 py-1.5 rounded hover:bg-red-50 transition"
            [ngClass]="{'bg-red-100 ring-2 ring-red-400': isPunishMode}">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            {{ isPunishMode ? 'Cancelar Gestión' : 'Gestionar Castigo' }}
          </button>
        </div>
      </div>

      <!-- Resumen financiero rápido -->
      <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div class="bg-blue-50 p-4 rounded-xl border border-blue-200">
          <p class="text-xs font-medium text-blue-600 mb-1">Total a Pagar</p>
          <p class="text-lg font-bold text-blue-800">{{ getTotalAmount() | currency }}</p>
        </div>
        <div class="bg-green-50 p-4 rounded-xl border border-green-200">
          <p class="text-xs font-medium text-green-600 mb-1">Pagado</p>
          <p class="text-lg font-bold text-green-800">{{ enrollment.amountPaid | currency }}</p>
        </div>
        <div class="bg-orange-50 p-4 rounded-xl border border-orange-200">
          <p class="text-xs font-medium text-orange-600 mb-1">Pendiente</p>
          <p class="text-lg font-bold text-orange-800">{{ enrollment.remainingBalance | currency }}</p>
        </div>
        <div class="bg-red-50 p-4 rounded-xl border border-red-200">
          <p class="text-xs font-medium text-red-600 mb-1">Vencido</p>
          <p class="text-lg font-bold text-red-800">{{ getOverdueAmount() | currency }}</p>
        </div>
      </div>
    </div>

    <!-- Panel de Gestión de Castigo -->
    <div *ngIf="isPunishMode" class="mb-6 p-4 bg-red-50 rounded-xl border-2 border-red-200 shadow-sm animate-fade-in">
      <div class="flex items-center gap-2 mb-4">
        <div class="p-2 bg-red-100 rounded-lg">
          <svg class="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <div>
          <h3 class="font-bold text-red-900">Modo de Gestión de Castigo</h3>
          <p class="text-sm text-red-700">Selecciona las cuotas que deseas castigar o descastigar manualmenfe.</p>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Razón del cambio <span
              class="text-red-500">*</span></label>
          <input [(ngModel)]="punishReason" type="text"
            class="w-full rounded-md border-gray-300 shadow-sm focus:border-red-500 focus:ring-red-500"
            placeholder="Ej: Acuerdo de pago incumplido / Error operativo">
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Notas adicionales (Opcional)</label>
          <input [(ngModel)]="punishNotes" type="text"
            class="w-full rounded-md border-gray-300 shadow-sm focus:border-red-500 focus:ring-red-500"
            placeholder="Detalles adicionales...">
        </div>
      </div>

      <div class="flex items-center justify-between bg-white p-3 rounded-lg border border-red-100">
        <span class="text-sm font-medium text-gray-600">
          <span class="font-bold text-red-600">{{ selectedPlanIds.length }}</span> cuotas seleccionadas
        </span>
        <div class="flex gap-2">
          <button (click)="executePunishAction('punish')" [disabled]="selectedPlanIds.length === 0 || !punishReason"
            class="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed font-medium text-sm transition flex items-center gap-2">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
            </svg>
            Castigar Seleccionadas
          </button>
          <button (click)="executePunishAction('unpunish')" [disabled]="selectedPlanIds.length === 0 || !punishReason"
            class="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed font-medium text-sm transition flex items-center gap-2">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            Descastigar
          </button>
        </div>
      </div>
    </div>

    <!-- Tabla rediseñada -->
    <div class="overflow-x-auto rounded-xl border border-gray-200 shadow-sm">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="w-12" *ngIf="!isPunishMode"></th>
            <th class="w-12 px-4 py-3 bg-red-50" *ngIf="isPunishMode">
              <input type="checkbox" (change)="selectAllPlans()"
                [checked]="selectedPlanIds.length === enrollment.paymentPlans.length && enrollment.paymentPlans.length > 0"
                class="rounded border-gray-300 text-red-600 focus:ring-red-500">
            </th>
            <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Cuota</th>
            <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Vencimiento</th>
            <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Estado Financiero</th>
            <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Progreso</th>
            <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Estado</th>
            <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Acciones</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
          <ng-container *ngFor="let plan of enrollment.paymentPlans">
            <tr [ngClass]="{
              'bg-amber-50/50': isPaymentOverdue(plan) && !plan.isPunished,
              'bg-red-50/70': plan.isPunished
            }" class="hover:bg-gray-50">
              <td *ngIf="!isPunishMode" class="hover:bg-gray-50 transition cursor-pointer text-center px-2"
                (click)="toggleCollapse(plan)">
                <svg [class.rotate-180]="!plan.isCollapsed" class="w-5 h-5 text-gray-400 transition-transform"
                  viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                    clip-rule="evenodd" />
                </svg>
              </td>
              <td *ngIf="isPunishMode" class="text-center px-4 py-3 bg-red-50/30">
                <input type="checkbox" [checked]="isPlanSelected(plan.id)" (change)="togglePlanSelection(plan.id)"
                  [disabled]="plan.paymentStatus === 'PAID'"
                  class="rounded border-gray-300 text-red-600 focus:ring-red-500 w-5 h-5 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">
              </td>
              <td class="px-4 py-3 font-medium text-gray-900">
                <div class="flex items-center gap-2">
                  <span>#{{ plan.installmentNumber }}</span>
                  <span *ngIf="plan.isCurrent"
                    class="px-2 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded-full">Actual</span>
                  <!-- 🆕 Indicador de cartera castigada -->
                  <span *ngIf="plan.isPunished"
                    class="px-2 py-1 text-xs font-bold bg-red-200 text-red-800 rounded-full flex items-center gap-1">
                    <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                        d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                        clip-rule="evenodd" />
                    </svg>
                    Castigada
                  </span>
                </div>
              </td>
              <td class="px-4 py-3">
                <div class="text-sm text-gray-900">{{ plan.dueDate | date:'mediumDate' }}</div>
                <div *ngIf="isPaymentOverdue(plan)" class="text-xs text-red-600 mt-1">
                  {{ getDaysOverdue(plan) }} días de atraso
                </div>
              </td>
              <!-- Estado Financiero -->
              <td class="px-6 py-4">
                <div class="space-y-1">
                  <div class="flex justify-between items-center text-xs">
                    <span class="text-gray-500">Monto cuota:</span>
                    <div class="text-right">
                      <span class="font-medium text-gray-800">{{ formatCurrencyValue(plan.amountToPay,
                        enrollment?.currencySymbol, enrollment?.currencyCode) }}</span>
                      <span *ngIf="isInternationalEnrollment" class="text-purple-500 ml-1 block">≈ {{
                        calculatePlanCOPEquivalent(plan, plan.amountToPay) }}</span>
                    </div>
                  </div>
                  <div class="flex justify-between items-center text-xs">
                    <span class="text-green-600">Pagado:</span>
                    <div class="text-right">
                      <span class="font-medium text-green-700">{{ formatCurrencyValue(plan.amountPaid,
                        enrollment?.currencySymbol, enrollment?.currencyCode) }}</span>
                      <span *ngIf="isInternationalEnrollment" class="text-purple-500 ml-1 block">≈ {{
                        calculatePlanCOPEquivalent(plan, plan.amountPaid) }}</span>
                    </div>
                  </div>
                  <div class="flex justify-between items-center text-xs">
                    <span class="text-red-600">Pendiente:</span>
                    <div class="text-right">
                      <span class="font-medium text-red-700">{{ formatCurrencyValue((plan.amountToPay -
                        plan.amountPaid), enrollment?.currencySymbol, enrollment?.currencyCode) }}</span>
                      <span *ngIf="isInternationalEnrollment" class="text-purple-500 ml-1 block">≈ {{
                        calculatePlanCOPEquivalent(plan, plan.amountToPay - plan.amountPaid) }}</span>
                    </div>
                  </div>
                </div>
              </td>

              <!-- Progreso de Pagos -->
              <td class="px-6 py-4">
                <div class="space-y-2">
                  <div class="flex justify-between text-xs">
                    <span class="text-gray-500">Cuota #{{ plan.installmentNumber }}</span>
                    <span class="font-medium text-gray-700">
                      {{ (plan.amountToPay > 0 ? ((plan.amountPaid / plan.amountToPay) * 100) : 0) | number:'1.0-1' }}%
                    </span>
                  </div>
                  <div class="w-full bg-gray-200 rounded-full h-2">
                    <div
                      class="bg-gradient-to-r from-green-400 to-green-600 h-2 rounded-full transition-all duration-300"
                      [style.width.%]="plan.amountToPay > 0 ? ((plan.amountPaid / plan.amountToPay) * 100) : 0">
                    </div>
                  </div>
                  <div class="flex justify-between text-xs">
                    <span class="inline-flex items-center gap-1 text-green-600" *ngIf="plan.paymentStatus === 'PAID'">
                      <span class="w-2 h-2 bg-green-500 rounded-full"></span>
                      Completada
                    </span>
                    <span class="inline-flex items-center gap-1 text-blue-600"
                      *ngIf="plan.paymentStatus === 'PARTIALLY_PAID'">
                      <span class="w-2 h-2 bg-blue-500 rounded-full"></span>
                      Parcial
                    </span>
                    <span class="inline-flex items-center gap-1 text-orange-600"
                      *ngIf="plan.paymentStatus === 'PENDING'">
                      <span class="w-2 h-2 bg-orange-500 rounded-full"></span>
                      Pendiente
                    </span>
                    <span class="inline-flex items-center gap-1 text-red-600" *ngIf="plan.paymentStatus === 'OVERDUE'">
                      <span class="w-2 h-2 bg-red-500 rounded-full"></span>
                      Vencida
                    </span>
                    <span class="inline-flex items-center gap-1 text-blue-600"
                      *ngIf="plan.paymentStatus === 'LINK_GENERATED'">
                      <span class="w-2 h-2 bg-blue-500 rounded-full"></span>
                      Link generado
                    </span>
                  </div>
                </div>
              </td>
              <td class="px-4 py-3">
                <div class="flex items-center gap-2">
                  <span class="w-2 h-2 rounded-full" [ngClass]="{
                  'bg-green-500': plan.paymentStatus === 'PAID',
                  'bg-amber-500': plan.paymentStatus === 'PENDING',
                  'bg-red-600': plan.paymentStatus === 'OVERDUE',
                  'bg-blue-500': plan.paymentStatus === 'LINK_GENERATED'
                }"></span>
                  <span class="text-sm font-medium" [ngClass]="{
                  'text-green-700': plan.paymentStatus === 'PAID',
                  'text-amber-700': plan.paymentStatus === 'PENDING',
                  'text-red-700': plan.paymentStatus === 'OVERDUE',
                  'text-blue-700': plan.paymentStatus === 'LINK_GENERATED'
                }">
                    {{ getPaymentStatusLabel(plan.paymentStatus) }}
                  </span>
                </div>
              </td>
              <td class="px-4 py-3">
                <div class="flex gap-2">
                  <a [routerLink]="['/dashboard/income-receipts/new']"
                    [queryParams]="{participantId: enrollment.participant.id, projectId: enrollment.project.id, enrollmentId: enrollment.id, installmentNumber: plan.installmentNumber}"
                    *ngIf="plan.paymentStatus !== 'PAID'"
                    class="text-sm text-blue-600 hover:text-blue-800 font-medium flex items-center gap-1">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
                    </svg>
                    Pagar
                  </a>
                  <button class="text-gray-400 hover:text-gray-600">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>

            <!-- Detalles colapsables simplificados -->
            <tr *ngIf="!plan.isCollapsed" class="bg-gray-50">
              <td colspan="7" class="px-4 py-3">
                <div class="pl-6 border-l-2" [ngClass]="plan.isPunished ? 'border-red-400' : 'border-blue-200'">
                  <h4 class="text-sm font-medium text-gray-700 mb-3">Detalles del Pago</h4>

                  <!-- 🆕 Información de Cartera Castigada -->
                  <div *ngIf="plan.isPunished" class="mb-4 p-4 bg-red-50 rounded-lg border border-red-200">
                    <h5 class="text-sm font-bold text-red-800 flex items-center gap-2 mb-3">
                      <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                          d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                          clip-rule="evenodd" />
                      </svg>
                      Cartera Castigada
                    </h5>
                    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div>
                        <p class="text-xs font-medium text-red-600">Tipo de Movimiento:</p>
                        <p class="text-sm font-semibold text-red-900">{{ getMovementTypeLabel(plan.movementType) }}</p>
                      </div>
                      <div *ngIf="plan.movementDate">
                        <p class="text-xs font-medium text-red-600">Fecha del Castigamiento:</p>
                        <p class="text-sm font-semibold text-red-900">{{ plan.movementDate | date:'medium' }}</p>
                      </div>
                      <div>
                        <p class="text-xs font-medium text-red-600">Monto Castigado:</p>
                        <p class="text-sm font-semibold text-red-900">
                          {{ formatCurrencyValue(plan.amountToPay - (plan.amountPaid || 0), enrollment?.currencySymbol,
                          enrollment?.currencyCode) }}
                        </p>
                        <p *ngIf="isInternationalEnrollment" class="text-xs text-gray-400 mt-1">
                          ≈ {{ calculatePlanCOPEquivalent(plan, plan.amountToPay - (plan.amountPaid || 0)) }}
                        </p>
                      </div>
                    </div>
                    <div *ngIf="plan.observations" class="mt-3 p-3 bg-red-100 rounded">
                      <p class="text-xs font-medium text-red-600 mb-1">📝 Observaciones:</p>
                      <p class="text-sm text-red-900">{{ plan.observations }}</p>
                    </div>
                  </div>

                  <!-- Payment Link Manager -->
                  <div class="mb-4" *ngIf="plan.paymentLinkUrl">
                    <app-payment-link-manager [paymentLinkUrl]="plan.paymentLinkUrl"
                      [paymentLinkId]="plan.paymentLinkId" [isActive]="plan.paymentLinkActive !== false"
                      [showDeactivateButton]="true" [size]="'sm'" (paymentLinkDeactivated)="onPaymentLinkDeactivated()">
                    </app-payment-link-manager>
                  </div>

                  <!-- Resumen de recibos -->
                  <div *ngFor="let receipt of plan.incomeReceipts" class="mb-4 last:mb-0">
                    <div class="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
                      <div class="flex justify-between items-start mb-3">
                        <div>
                          <p class="text-sm font-medium text-gray-900">{{ receipt.concept }}</p>
                          <p class="text-xs text-gray-500">{{ receipt.createdAt | date:'mediumDate' }}</p>
                        </div>
                        <span class="text-xs font-medium px-2 py-1 rounded-full"
                          [ngClass]="receipt.isManualPayment ? 'bg-amber-100 text-amber-800' : 'bg-green-100 text-green-800'">
                          {{ receipt.isManualPayment ? 'Manual' : 'Automático' }}
                        </span>
                      </div>

                      <!-- Información de Tasa de Cambio (si aplica) -->
                      <div *ngIf="hasReceiptExchangeRate(receipt)"
                        class="bg-purple-50 p-3 rounded-lg border-l-4 border-purple-400 mb-3">
                        <h4 class="text-sm font-semibold mb-2 text-purple-800 flex items-center gap-2">
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round"
                              d="M12 8c-1.657 0-3 .672-3 1.5S10.343 11 12 11s3-.672 3-1.5S13.657 8 12 8zm0 8c-1.657 0-3 .672-3 1.5S10.343 19 12 19s3-.672 3-1.5S13.657 16 12 16zm0-4c-1.657 0-3 .672-3 1.5S10.343 15 12 15s3-.672 3-1.5S13.657 12 12 12z" />
                          </svg>
                          Información de Tasa de Cambio
                        </h4>
                        <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
                          <div>
                            <p class="text-xs text-purple-600 font-medium">Moneda Original:</p>
                            <p class="text-purple-900 font-semibold">{{ receipt.currencyCode }}</p>
                          </div>
                          <div>
                            <p class="text-xs text-purple-600 font-medium">Tasa de Cambio:</p>
                            <p class="text-purple-900 font-semibold">{{ receipt.exchangeRate | number:'1.2-4' }}</p>
                            <p class="text-xs text-purple-500" *ngIf="receipt.exchangeRateEffectiveDate">
                              {{ receipt.exchangeRateEffectiveDate | date:'short' }}
                            </p>
                          </div>
                          <div>
                            <p class="text-xs text-purple-600 font-medium">Monto Bruto (COP):</p>
                            <p class="text-purple-900 font-semibold">{{ getReceiptCOPEquivalent(receipt,
                              receipt.grossAmount) }}</p>
                          </div>
                          <div>
                            <p class="text-xs text-purple-600 font-medium">Monto Neto (COP):</p>
                            <p class="text-purple-900 font-semibold">{{ getReceiptCOPEquivalent(receipt,
                              receipt.netAmount) }}</p>
                          </div>
                        </div>
                        <p class="text-xs text-purple-400 mt-2">* Valores calculados con la tasa registrada al momento
                          del pago</p>
                      </div>

                      <!-- Información financiera del recibo -->
                      <div class="grid grid-cols-2 md:grid-cols-4 gap-3 mb-3">
                        <div>
                          <p class="text-xs text-gray-500">Bruto</p>
                          <p class="text-sm font-medium text-yellow-700">{{ formatCurrencyValue(receipt.grossAmount,
                            receipt.currencySymbol, receipt.currencyCode) }}</p>
                        </div>
                        <div>
                          <p class="text-xs text-gray-500">Descuentos</p>
                          <p class="text-sm font-medium text-red-700">{{ formatCurrencyValue(receipt.totalFees,
                            receipt.currencySymbol, receipt.currencyCode) }}</p>
                        </div>
                        <div>
                          <p class="text-xs text-gray-500">Neto</p>
                          <p class="text-sm font-medium text-green-700">{{ formatCurrencyValue(receipt.netAmount,
                            receipt.currencySymbol, receipt.currencyCode) }}</p>
                        </div>
                        <div>
                          <p class="text-xs text-gray-500">Método</p>
                          <p class="text-sm text-gray-700">{{ receipt.paymentMethod?.name || 'N/A' }}</p>
                        </div>
                      </div>

                      <!-- Acción para ver comprobante -->
                      <div class="pt-2 border-t border-gray-200">
                        <a [routerLink]="['/income-receipts/view', receipt.id]" target="_blank"
                          class="text-blue-600 hover:text-blue-800 text-sm font-medium inline-flex items-center gap-1">
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round"
                              d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                          </svg>
                          Ver comprobante completo
                        </a>
                      </div>
                    </div>
                  </div>

                  <!-- Estado vacío -->
                  <div *ngIf="plan.incomeReceipts?.length === 0" class="text-center py-4 text-gray-400 text-sm">
                    No se registran pagos para esta cuota
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <!-- Leyenda de estados -->
    <div class="mt-4 flex flex-wrap gap-4 items-center text-sm text-gray-600">
      <span class="flex items-center gap-2">
        <span class="w-2 h-2 rounded-full bg-green-500"></span>
        Pagado
      </span>
      <span class="flex items-center gap-2">
        <span class="w-2 h-2 rounded-full bg-amber-500"></span>
        Pendiente
      </span>
      <span class="flex items-center gap-2">
        <span class="w-2 h-2 rounded-full bg-red-600"></span>
        Vencido
      </span>
      <span class="flex items-center gap-2">
        <span class="w-2 h-2 rounded-full bg-blue-500"></span>
        Link generado
      </span>
      <!-- 🆕 Indicador de cartera castigada -->
      <span class="flex items-center gap-2">
        <span class="w-2 h-2 rounded-full bg-red-800"></span>
        Cartera Castigada
      </span>
    </div>

    <!-- 🆕 Resumen de Cartera Castigada -->
    <div *ngIf="hasPunishedInstallments()" class="mt-6 p-4 bg-red-50 rounded-xl border border-red-200">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-lg font-bold text-red-800 flex items-center gap-2">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          Resumen de Cartera Castigada
        </h3>
        <span class="px-3 py-1 text-sm font-bold bg-red-200 text-red-800 rounded-full">
          {{ getPunishedInstallments().length }} cuota(s)
        </span>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div class="bg-white p-4 rounded-lg border border-red-200">
          <p class="text-xs font-medium text-red-600 mb-1">Total Cartera Castigada</p>
          <p class="text-xl font-bold text-red-800">{{ getTotalPunishedAmount() | currency }}</p>
        </div>
        <div class="bg-white p-4 rounded-lg border border-red-200">
          <p class="text-xs font-medium text-red-600 mb-1">Cuotas Afectadas</p>
          <p class="text-xl font-bold text-red-800">
            {{ getPunishedInstallments().length }} de {{ enrollment.paymentPlans.length }}
          </p>
        </div>
        <div class="bg-white p-4 rounded-lg border border-red-200" *ngIf="enrollment.lastPortfolioMovementDate">
          <p class="text-xs font-medium text-red-600 mb-1">Fecha del Movimiento</p>
          <p class="text-lg font-bold text-red-800">{{ enrollment.lastPortfolioMovementDate | date:'shortDate' }}</p>
        </div>
      </div>
      <div *ngIf="enrollment.withdrawalReason" class="mt-4 p-3 bg-white rounded-lg border border-red-200">
        <p class="text-xs font-medium text-red-600 mb-1">📝 Razón / Observaciones del Castigamiento:</p>
        <p class="text-sm text-red-900">{{ enrollment.withdrawalReason }}</p>
      </div>
    </div>
  </section>

  <!-- 🆕 Ingresos Generales (Sin Plan de Pago) -->
  <section class="pt-8 mt-8 border-t border-gray-200">
    <!-- Encabezado -->
    <div class="mb-6">
      <div class="flex flex-wrap items-center justify-between gap-4 mb-6">
        <div>
          <h2 class="text-2xl font-semibold text-gray-800 flex items-center gap-2">
            <svg class="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
              </path>
            </svg>
            Ingresos Generales
          </h2>
          <p class="text-sm text-gray-500 mt-1">
            Pagos por servicios adicionales, certificados y otros conceptos
            <span *ngIf="generalIncomeReceipts.length > 0" class="ml-2 text-purple-600 font-medium">
              • {{ generalIncomeReceipts.length }} comprobante(s) registrado(s)
            </span>
          </p>
        </div>

        <!-- Botón para agregar nuevo ingreso general -->
        <div class="flex gap-3">
          <a [routerLink]="['/dashboard/income-receipts/new']"
            [queryParams]="{participantId: enrollment.participant.id, projectId: enrollment.project.id, enrollmentId: enrollment.id}"
            class="inline-flex items-center gap-2 bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition shadow-sm">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4"></path>
            </svg>
            Agregar Ingreso
          </a>
        </div>
      </div>

      <!-- Resumen financiero de ingresos generales -->
      <div class="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6" *ngIf="generalIncomeReceipts.length > 0">
        <div class="bg-purple-50 p-4 rounded-xl border border-purple-200">
          <p class="text-xs font-medium text-purple-600 mb-1">Total Ingresos</p>
          <p class="text-lg font-bold text-purple-800">
            {{ getTotalGeneralIncome() | currency }}
          </p>
        </div>
        <div class="bg-blue-50 p-4 rounded-xl border border-blue-200">
          <p class="text-xs font-medium text-blue-600 mb-1">Comprobantes</p>
          <p class="text-lg font-bold text-blue-800">{{ generalIncomeReceipts.length }}</p>
        </div>
        <div class="bg-green-50 p-4 rounded-xl border border-green-200">
          <p class="text-xs font-medium text-green-600 mb-1">Último Pago</p>
          <p class="text-sm font-bold text-green-800">
            {{ generalIncomeReceipts[0]?.createdAt | date:'shortDate' }}
          </p>
        </div>
      </div>
    </div>

    <!-- Lista de ingresos generales -->
    <div *ngIf="generalIncomeReceipts.length > 0" class="space-y-4">
      <div *ngFor="let receipt of generalIncomeReceipts; let i = index"
        class="bg-white border border-gray-200 rounded-xl p-5 shadow-sm hover:shadow-md transition-shadow">

        <!-- Header del comprobante -->
        <div class="flex justify-between items-start mb-4">
          <div class="flex-1">
            <div class="flex items-center gap-3 mb-2">
              <h3 class="text-lg font-semibold text-gray-900">{{ receipt.concept }}</h3>
              <span class="text-xs font-medium px-2 py-1 rounded-full"
                [ngClass]="receipt.isManualPayment ? 'bg-amber-100 text-amber-800' : 'bg-green-100 text-green-800'">
                {{ receipt.isManualPayment ? 'Manual' : 'Automático' }}
              </span>
            </div>
            <div class="flex items-center gap-4 text-sm text-gray-600">
              <span class="flex items-center gap-1">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                </svg>
                {{ receipt.createdAt | date:'medium' }}
              </span>
              <span class="flex items-center gap-1">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path>
                </svg>
                {{ receipt.paymentMethod?.name || 'N/A' }}
              </span>
              <span *ngIf="receipt.referenceNumber" class="flex items-center gap-1">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"></path>
                </svg>
                Ref: {{ receipt.referenceNumber }}
              </span>
            </div>
          </div>

          <!-- Monto destacado -->
          <div class="text-right">
            <p class="text-xs text-gray-500 mb-1">Monto Neto</p>
            <p class="text-2xl font-bold text-green-600">
              {{ formatCurrencyValue(receipt.netAmount, receipt.currencySymbol, receipt.currencyCode) }}
            </p>
          </div>
        </div>

        <!-- Información de Tasa de Cambio (si aplica) -->
        <div *ngIf="hasReceiptExchangeRate(receipt)"
          class="bg-purple-50 p-4 rounded-lg border-l-4 border-purple-400 mb-4">
          <h4 class="text-sm font-semibold mb-3 text-purple-800 flex items-center gap-2">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M12 8c-1.657 0-3 .672-3 1.5S10.343 11 12 11s3-.672 3-1.5S13.657 8 12 8zm0 8c-1.657 0-3 .672-3 1.5S10.343 19 12 19s3-.672 3-1.5S13.657 16 12 16zm0-4c-1.657 0-3 .672-3 1.5S10.343 15 12 15s3-.672 3-1.5S13.657 12 12 12z" />
            </svg>
            💱 Información de Tasa de Cambio
          </h4>
          <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
            <div>
              <p class="text-xs text-purple-600 font-medium">Moneda Original:</p>
              <p class="text-purple-900 font-semibold">{{ receipt.currencyCode }}</p>
            </div>
            <div>
              <p class="text-xs text-purple-600 font-medium">Tasa de Cambio:</p>
              <p class="text-purple-900 font-semibold">{{ receipt.exchangeRate | number:'1.2-4' }}</p>
              <p class="text-xs text-purple-500" *ngIf="receipt.exchangeRateEffectiveDate">
                {{ receipt.exchangeRateEffectiveDate | date:'short' }}
              </p>
            </div>
            <div>
              <p class="text-xs text-purple-600 font-medium">Monto Bruto (COP):</p>
              <p class="text-purple-900 font-semibold">{{ getReceiptCOPEquivalent(receipt, receipt.grossAmount) }}</p>
            </div>
            <div>
              <p class="text-xs text-purple-600 font-medium">Monto Neto (COP):</p>
              <p class="text-purple-900 font-semibold">{{ getReceiptCOPEquivalent(receipt, receipt.netAmount) }}</p>
            </div>
          </div>
          <p class="text-xs text-purple-400 mt-2">* Valores calculados con la tasa registrada al momento del pago</p>
        </div>

        <!-- Detalles financieros -->
        <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4 p-4 bg-gray-50 rounded-lg">
          <div>
            <p class="text-xs text-gray-500 mb-1">Monto Bruto</p>
            <p class="text-sm font-semibold text-yellow-700">
              {{ formatCurrencyValue(receipt.grossAmount, receipt.currencySymbol, receipt.currencyCode) }}
            </p>
          </div>
          <div>
            <p class="text-xs text-gray-500 mb-1">Descuentos</p>
            <p class="text-sm font-semibold text-red-700">
              {{ formatCurrencyValue(receipt.totalFees, receipt.currencySymbol, receipt.currencyCode) }}
            </p>
          </div>
          <div>
            <p class="text-xs text-gray-500 mb-1">Monto Neto</p>
            <p class="text-sm font-semibold text-green-700">
              {{ formatCurrencyValue(receipt.netAmount, receipt.currencySymbol, receipt.currencyCode) }}
            </p>
          </div>
          <div>
            <p class="text-xs text-gray-500 mb-1">Banco</p>
            <p class="text-sm text-gray-700">{{ receipt.bank?.bankName || 'N/A' }}</p>
          </div>
        </div>

        <!-- Observaciones (si existen) -->
        <div *ngIf="receipt.observations" class="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
          <p class="text-xs font-medium text-blue-600 mb-1">📝 Observaciones:</p>
          <p class="text-sm text-blue-900">{{ receipt.observations }}</p>
        </div>

        <!-- Descuentos aplicados (si existen) -->
        <div *ngIf="receipt.feeDetails && receipt.feeDetails.length > 0" class="mb-4">
          <p class="text-xs font-medium text-gray-600 mb-2">💰 Descuentos Aplicados:</p>
          <div class="space-y-2">
            <div *ngFor="let fee of receipt.feeDetails"
              class="flex justify-between items-center p-2 bg-red-50 rounded border border-red-200">
              <div>
                <p class="text-sm font-medium text-red-900">{{ fee.feeType?.name || 'Descuento' }}</p>
                <p class="text-xs text-red-600">{{ fee.description }}</p>
              </div>
              <p class="text-sm font-bold text-red-700">-{{ fee.appliedAmount | currency }}</p>
            </div>
          </div>
        </div>

        <!-- Acción para ver comprobante completo -->
        <div class="pt-3 border-t border-gray-200">
          <a [routerLink]="['/income-receipts/view', receipt.id]" target="_blank"
            class="text-purple-600 hover:text-purple-800 text-sm font-medium inline-flex items-center gap-2 transition">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
            </svg>
            Ver comprobante completo
          </a>
        </div>
      </div>
    </div>

    <!-- Estado vacío -->
    <div *ngIf="generalIncomeReceipts.length === 0"
      class="text-center py-12 bg-gray-50 rounded-xl border-2 border-dashed border-gray-300">
      <svg class="w-16 h-16 mx-auto text-gray-400 mb-4" fill="none" stroke="currentColor" stroke-width="1.5"
        viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
        </path>
      </svg>
      <h3 class="text-lg font-semibold text-gray-700 mb-2">No hay ingresos generales registrados</h3>
      <p class="text-sm text-gray-500 mb-4">
        Los ingresos generales son pagos por servicios adicionales como certificados, constancias, etc.
      </p>
      <a [routerLink]="['/dashboard/income-receipts/new']"
        [queryParams]="{participantId: enrollment.participant.id, projectId: enrollment.project.id, enrollmentId: enrollment.id}"
        class="inline-flex items-center gap-2 bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition shadow-sm">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4"></path>
        </svg>
        Agregar Primer Ingreso
      </a>
    </div>
  </section>

</div>